<template>
  <div class="choosepeople">
    <!-- 选人界面 -->
    <div v-show="choosedStatus" style="width: 100%;height: 100%;overflow: auto;">
      <van-nav-bar title="请选择" fixed left-arrow @click-left="goBack" z-index="3" />
      <div class="searchBox">
        <div class="search">
          <i></i>
          <span>搜索</span>
        </div>
      </div>
      <div class="big_box" v-show="status">
        <div class="myList">
          <ul class="myUl">
            <li class="myLi" @click="getMyFriend">
              <div class="avatar">
                <img src="/img/myfriend.png" alt />
              </div>
              <div class="name">我的好友</div>
            </li>
            <li class="myLi" @click="getMyGroup" v-if="!ban_org">
              <div class="avatar">
                <img src="/img/room.png" alt />
              </div>
              <div class="name">我的群组</div>
            </li>
            <li class="myLi" @click="getMyOrg()">
              <div class="avatar">
                <img src="/img/org.png" alt />
              </div>
              <div class="name">我的组织</div>
            </li>
            <li class="myLi" @click="getdq()">
              <div class="avatar">
                <img src="/img/org.png" alt />
              </div>
              <div class="name">地区</div>
            </li>
            <li class="myLi" @click="gethy()">
              <div class="avatar">
                <img src="/img/org.png" alt />
              </div>
              <div class="name">行业</div>
            </li>
          </ul>
        </div>
        <!-- 最近联系 -->
        <div class="recent">常用</div>
        <div class="recentList">
          <el-checkbox-group v-model="result">
            <el-checkbox
              v-for="(item, index) in slist"
              :key="index"
              :label="item.unit.unitId"
              v-if="item.type == 1 || (item.type == 2 && showRecentGroup && !ban_org)"
              @change="recentChange($event, item)"
            >
              <div class="avatar" v-if="item.type == 1&&item.users.avatar">
                <img :src="item.users.avatar" alt />
              </div>
              <div class="avatar" v-if="item.type == 2">
                <img :src="item.roominfo.logopath" alt />
              </div>
              <div
                class="no_avatar"
                v-if="!item.users.avatar&&item.type == 1"
              >{{item.users.sumname.substr(-2, 2)}}</div>
              <div class="name" v-if="item.type == 1">{{item.users.sumname}}</div>
              <div class="name" v-if="item.type == 2">{{item.roominfo.roomname}}</div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="bread" v-show="!status">
        <ul class="bread_ul">
          <li @click="changeStatus">联系人</li>
          <li
            v-for="(item, index) in breadArr"
            :key="index"
            v-if="!org_status"
            @click="goSon($event, item)"
          >{{'>' + item.name}}</li>
          <li
            v-for="(item, index) in breadArr"
            :key="index"
            v-if="!hy_status"
            @click="gohySon($event, item)"
          >{{'>' + item.name}}</li>
          <li
            v-for="(item, index) in breadArr"
            :key="index"
            v-if="!dq_status"
            @click="godqSon($event, item)"
          >{{'>' + item.name}}</li>
        </ul>
      </div>
      <!-- 好友列表 -->
      <div class="people_list" v-show="!friend_status">
        <!-- 左侧成员列表 -->
        <div class="member_list">
          <ul class="list_ul">
            <li class="section" v-for="(itemSort, index) in letters" :key="index">
              <p class="letter" :id="itemSort">{{itemSort}}</p>
              <el-checkbox-group :max="limit==-1?99999999:limit" v-model="peopleList">
                <!-- <div v-for="(item, index) in friend_list" v-if=""> -->
                <el-checkbox
                  v-for="(item, index) in friend_list"
                  :key="index"
                  :label="parseInt(item.umid)"
                  @change="chooseCheck($event, item)"
                  v-if="item.capitalize == itemSort"
                >
                  <div class="avatar">
                    <img :src="item.avatar" alt v-if="item.avatar" />
                    <div class="noAvatar" v-if="!item.avatar">{{item.name.substr(-2, 2)}}</div>
                  </div>
                  <div class="name_phone">
                    <p class="name">{{item.name}}</p>
                    <p class="phone">{{item.sphone}}</p>
                  </div>
                  <div class="company">
                    <p>{{item.job}}</p>
                    <p>{{item.company}}</p>
                  </div>
                </el-checkbox>
                <!-- </div> -->
              </el-checkbox-group>
            </li>
          </ul>
        </div>
      </div>
      <!-- 我的群组 -->
      <div class="group_list" v-show="!group_status">
        <div class="groupUl">
          <el-checkbox-group v-model="groupList">
            <el-checkbox
              v-for="(item, index) in group_list"
              :key="index"
              :label="item.id"
              @change="chooseCheck($event, item)"
            >
              <div class="avatar">
                <img :src="item.avatar" alt />
              </div>
              <div class="right">
                <span class="name">{{item.name}}</span>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <!-- 我的组织 -->
      <div class="org_list" v-show="!org_status">
        <div class="orglist">
          <div class="org_ul" v-show="orgRoot">
            <el-checkbox-group v-model="orgList" :disabled="ban_org">
              <li v-for="(item, index) in org_list" :key="index">
                <el-checkbox :label="parseInt(item.id)" @change="chooseCheck($event, item)">
                  <div class="noAvatar" v-if="!item.avatar"></div>
                  <div class="avatar" v-if="item.avatar">
                    <img :src="item.avatar" alt />
                  </div>
                  <div class="name">
                    <span>{{item.name}}</span>
                  </div>
                </el-checkbox>
                <div class="next" @click.stop="getBranch(item)">
                  <img src="/img/nextBranch.png" alt />
                  下级
                </div>
              </li>
            </el-checkbox-group>
          </div>
          <div class="org_ul" v-show="!orgRoot && branchStatus">
            <el-checkbox-group v-model="branchList" :disabled="ban_org">
              <li v-for="(item, index) in orgmember" :key="index">
                <el-checkbox
                  :label="parseInt(item.id)"
                  @change="chooseCheck($event, item)"
                  v-if="item.type == '2'"
                >
                  <div class="rightBox orgBox">
                    <div class="name">{{item.name}}</div>
                  </div>
                </el-checkbox>
                <div class="next" @click.stop="getBranch(item)" v-if="item.type == '2'">
                  <img src="/img/nextBranch.png" alt />
                  <span>下级</span>
                </div>
              </li>
            </el-checkbox-group>
          </div>
          <div class="org_ul manList" v-show="!orgRoot && peopleStatus">
            <el-checkbox-group v-model="peopleList">
              <el-checkbox
                v-for="(item, index) in orgmember"
                :key="index"
                :label="parseInt(item.umid)"
                @change="chooseCheck($event, item)"
                v-if="item.type != '2'"
              >
                <div class="rightBox orgBox">
                  <div class="avatar" v-if="item.avatar">
                    <img :src="item.avatar" alt />
                  </div>
                  <div class="noAvatar" v-if="!item.avatar">{{item.name.substr(-2, 2)}}</div>
                  <div class="name">{{item.name}}</div>
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <!-- 我的行业 -->
      <div class="org_list" v-show="!hy_status">
        <div class="orglist">
          <div class="org_ul" v-show="hyRoot">
            <el-checkbox-group v-model="hyList">
              <li v-for="(item, index) in hy_list" :key="index">
                <el-checkbox :label="item.id" @change="chooseCheck($event, item)">
                  <div class="name">
                    <span>{{item.name}}</span>
                  </div>
                </el-checkbox>
                <div class="next" @click.stop="getBranchhy(item)">
                  <img src="/img/nextBranch.png" alt />
                  下级
                </div>
              </li>
            </el-checkbox-group>
          </div>
          <div class="org_ul" v-show="!hyRoot">
            <el-checkbox-group v-model="hyList" :disabled="ban_org">
              <li v-for="(item, index) in hymember" :key="index">
                <el-checkbox :label="item.id" @change="chooseCheck($event, item)">
                  <div class="rightBox orgBox">
                    <div class="name">{{item.name}}</div>
                  </div>
                </el-checkbox>
                <div class="next" @click.stop="getBranchhy(item)">
                  <img src="/img/nextBranch.png" alt />
                  <span>下级</span>
                </div>
              </li>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <!-- 我的地区-->
      <div class="org_list" v-show="!dq_status">
        <div class="orglist">
          <div class="org_ul" v-show="dqRoot">
            <el-checkbox-group v-model="dqList">
              <li v-for="(item, index) in dq_list" :key="index">
                <el-checkbox :label="item.id" @change="chooseCheck($event, item)">
                  <div class="name">
                    <span>{{item.name}}</span>
                  </div>
                </el-checkbox>
                <div class="next" @click.stop="getBranchdq(item)">
                  <img src="/img/nextBranch.png" alt />
                  下级
                </div>
              </li>
            </el-checkbox-group>
          </div>
          <div class="org_ul" v-show="!dqRoot">
            <el-checkbox-group v-model="dqList" :disabled="ban_org">
              <li v-for="(item, index) in dqmember" :key="index">
                <el-checkbox :label="item.id" @change="chooseCheck($event, item)">
                  <div class="rightBox orgBox">
                    <div class="name">{{item.name}}</div>
                  </div>
                </el-checkbox>
                <div class="next" @click.stop="getBranchdq(item)">
                  <img src="/img/nextBranch.png" alt />
                  <span>下级</span>
                </div>
              </li>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="sure">
        <div class="left" @click="toChoosedPeople">已选择:{{peopleTotal}}人</div>
        <div class="left" @click="toChoosedPeople">,{{dqTotal}}地区</div>
        <div class="left" @click="toChoosedPeople">,{{hyTotal}}行业</div>
        <div class="choosedPeople" v-if="groupTotal > 0" @click="toChoosedPeople">,{{groupTotal}}个群</div>
        <div class="choosedPeople" v-if="orgTotal > 0" @click="toChoosedPeople">,{{orgTotal}}个组织</div>
        <div
          class="choosedPeople"
          v-if="branchTotal > 0"
          @click="toChoosedPeople"
        >,{{branchTotal}}个部门</div>
        <el-button
          type="primary"
          v-if="!trueBtnStatus"
          class="right"
          size="small"
          @click="submit"
        >确定({{allTotal}}/999)</el-button>
        <el-button
          type="primary"
          v-if="trueBtnStatus"
          class="right"
          size="small"
          @click="submit"
          :disabled="peopleTotal < 2"
        >确定({{allTotal}}/999)</el-button>
      </div>
    </div>
    <!-- 已选中的人 -->
    <div class="special" v-show="!choosedStatus">
      <van-nav-bar title="已选择" fixed left-arrow @click-left="goBack1" z-index="2" />
      <div class="big_box">
        <ul class="listUl">
          <div class="classify" v-if="choosedPeople.length > 0">
            好友
            <span style="float: right; color: #fb6155" @click="removeAll(1)">移除所有好友</span>
          </div>
          <li class="listLi" v-for="(item, index) in choosedPeople" :key="index">
            <div class="avatar" v-if="item.avatar&&!item.users">
              <img :src="item.avatar" alt />
            </div>
            <div class="avatar" v-if="item.users&&item.users.avatar">
              <img :src="item.users.avatar" alt />
            </div>
            <div class="no_avatar" v-if="!item.avatar&&item.name">{{item.name.substr(-2, 2)}}</div>
            <div
              class="no_avatar"
              v-if="item.users&&!item.users.avatar"
            >{{item.users.sumname.substr(-2, 2)}}</div>
            <div class="name" v-if="item.name">{{item.name}}</div>
            <div class="name" v-if="item.users">{{item.users.sumname}}</div>
            <div class="remove" @click="removeThis(item, index)">移除</div>
          </li>
          <div class="classify" v-if="choosedRoomuser.length > 0">
            管理员
            <span style="float: right; color: #fb6155" @click="removeAll(1)">移除所有管理员</span>
          </div>
          <li class="listLi" v-for="(item, index) in choosedRoomuser" :key="index">
            <div class="avatar" v-if="item.avatar&&!item.users">
              <img :src="item.avatar" alt />
            </div>
            <div class="avatar" v-if="item.users&&item.users.avatar">
              <img :src="item.users.avatar" alt />
            </div>
            <div class="no_avatar" v-if="!item.avatar&&item.name">{{item.name.substr(-2, 2)}}</div>
            <div
              class="no_avatar"
              v-if="item.users&&!item.users.avatar"
            >{{item.users.sumname.substr(-2, 2)}}</div>
            <div class="name" v-if="item.name">{{item.name}}</div>
            <div class="name" v-if="item.users">{{item.users.sumname}}</div>
            <div class="remove" @click="removeThis(item, index,3)">移除</div>
          </li>
          <div class="classify" v-if="choosedGroup.length > 0">
            群
            <span style="float: right; color: #fb6155" @click="removeAll(2)">移除所有群</span>
          </div>
          <li class="listLi" v-for="(item, index) in choosedGroup" :key="index">
            <div class="avatar" v-if="item.roominfo">
              <img :src="item.roominfo.logopath" alt />
            </div>
            <div class="avatar" v-if="!item.roominfo">
              <img :src="item.avatar" alt />
            </div>
            <div class="name" v-if="item.roominfo">{{item.roominfo.roomname}}</div>
            <div class="name" v-if="!item.roominfo">{{item.name}}</div>
            <div class="remove" @click="removeThis(item, index)">移除</div>
          </li>
          <div class="classify" v-if="choosedOrg.length > 0">
            组织
            <span style="float: right; color: #fb6155" @click="removeAll(3)">移除所有组织</span>
          </div>
          <li class="listLi" v-for="(item, index) in choosedOrg" :key="index">
            <div class="avatar" v-if="item.avatar&&!item.users">
              <img :src="item.avatar" alt />
            </div>
            <div class="name" v-if="item.name">{{item.name}}</div>
            <div class="remove" @click="removeThis(item, index)">移除</div>
          </li>
          <div class="classify" v-if="choosedBranch.length > 0">
            部门
            <span style="float: right; color: #fb6155" @click="removeAll(4)">移除所有部门</span>
          </div>
          <li class="listLi" v-for="(item, index) in choosedBranch" :key="index">
            <div class="name" v-if="item.name">{{item.name}}</div>
            <div class="remove" @click="removeThis(item, index)">移除</div>
          </li>
          <div class="classify" v-if="choosedhy.length > 0">
            行业
            <span style="float: right; color: #fb6155" @click="removeAll(5)">移除所有行业</span>
          </div>
          <li class="listLi" v-for="(item, index) in choosedhy" :key="index">
            <div class="name" v-if="item.name">{{item.name}}</div>
            <div class="remove" @click="removeThis(item, index,0)">移除</div>
          </li>
          <div class="classify" v-if="chooseddq.length > 0">
            地区
            <span style="float: right; color: #fb6155" @click="removeAll(6)">移除所有地区</span>
          </div>
          <li class="listLi" v-for="(item, index) in chooseddq" :key="index">
            <div class="name" v-if="item.name">{{item.name}}</div>
            <div class="remove" @click="removeThis(item, index,1)">移除</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import sort from "./Alphabetical_sort.js";
export default {
  name: "umMselector",
  props: {
    usertype: {
      type: String,
      default: ""
    },
    createtype: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: -1
    },
    friend: {
      type: Array,
      default: []
    },
    roomuser: {
      type: Array,
      default: []
    },
    group: {
      type: Array,
      default: []
    },
    org: {
      type: Array,
      default: []
    },
    hy: {
      type: Array,
      default: []
    },
    dq: {
      type: Array,
      default: []
    },
    ban_org: {
      // 用于屏蔽掉群、组织、部门，但是保留组织中的人
      type: Boolean,
      default: false
    },
    showRecentGroup: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      result: [],
      slist: [],
      recentIdArr: [],
      status: true,
      friend_status: true,
      group_status: true,
      org_status: true,
      hy_status: true,
      dq_status: true,
      letters: [],
      friend_list: [],
      group_list: [],
      org_list: [],
      hy_list: [],
      dq_list: [],
      breadArr: [],
      orgmember: [],
      orgRoot: true,
      hyRoot: true,
      dqRoot: true,
      orgid: "",
      branchId: "",
      detailArr: [],
      peopleTotal: 0,
      groupTotal: 0,
      orgTotal: 0,
      branchTotal: 0,
      dqTotal: 0,
      hyTotal: 0,
      allTotal: 0,
      choosedStatus: true,
      choosedList: [],
      peopleList: [],
      groupList: [],
      orgList: [],
      hyList: [],
      dqList: [],
      branchList: [],
      clickFriend: true,
      clickGroup: true,
      clickOrg: true,
      clickhy: true,
      clickdq: true,
      openType: this.usertype,
      choosedPeople: [],
      choosedRoomuser: [],
      choosedGroup: [],
      choosedOrg: [],
      choosedhy: [],
      chooseddq: [],
      choosedBranch: [],
      trueBtnStatus: false,
      strChineseFirstPY: sort.strChineseFirstPY(),
      oMultiDiff: sort.oMultiDiff(),
      peopleStatus: false,
      branchStatus: false
    };
  },
  created() {
    this.getRecent();
  },
  watch: {
    peopleList: function(val, oldval) {
      this.peopleTotal = val.length;
    },
    groupList: function(val, oldval) {
      this.groupTotal = val.length;
    },
    orgList: function(val, oldval) {
      this.orgTotal = val.length;
    },
    branchList: function(val, oldval) {
      this.branchTotal = val.length;
    },
    dqList: function(val, oldval) {
      this.dqTotal = val.length;
    },
    hyList: function(val, oldval) {
      this.hyTotal = val.length;
    }
  },
  mounted() {
    var that = this;
    window.goBack = that.goBack;
    if (that.openType == "people") {
      that.getMyFriend();
    } else if (that.openType == "group") {
      that.getMyGroup();
    } else if (that.openType == "org") {
      that.getMyOrg();
    } else if (that.openType == "roomuser") {
      that.status = false;
      that.friend_status = false;
      that.friend_list = that.roomuser;
      that.peopleList=[];
      let obj = {};
      let arr = [];
      let arr1 = [];
      that.friend_list.forEach(function(value, index, array) {
        value.avatar=value.userinfo.avatar
        value.capitalize = that
          .makePy(value.name)[0]
          .toUpperCase()
          .substr(0, 1);
        var reg = /^[A-Z]+$/;
        if (!value.capitalize.match(reg)) {
          value.capitalize = "#";
        }
        if (!obj[value.capitalize]) {
          obj[value.capitalize] = true;
          arr.push(value.capitalize);
        }
        if(that.createtype=='administrators'){
          if(value.usertype=='1'){
            arr1.push(value)
            that.peopleList.push(parseInt(value.umid));
          }
        }else if(that.createtype=='assignment'){
          if(value.usertype=='0'){
            arr1.push(value)
            that.peopleList.push(parseInt(value.umid));
          }
        }
        
      });
      //字母列表排序
      that.letters = arr.sort();
      that.choosedRoomuser = arr1;
    }
    that.friend.forEach(item => {
      if (item.unit) {
        that.result.push(parseInt(item.unit.unitId));
        that.peopleList.push(parseInt(item.unit.unitId));
      } else if (item.umid) {
        that.result.push(parseInt(item.umid));
        that.peopleList.push(parseInt(item.umid));
      }
    });
    that.group.forEach(item => {
      if (item.unit) {
        that.result.push(item.unit.unitId);
        that.groupList.push(item.unit.unitId);
      } else {
        that.result.push(item.id);
        that.groupList.push(item.id);
      }
    });
    that.dq.forEach(item => {
      that.result.push(item.id);
      that.dqList.push(item.id);
    });
    that.hy.forEach(item => {
      that.result.push(item.id);
      that.hyList.push(item.id);
    });
    that.org.forEach(item => {
      if (item.itype == "3" && item.type == "2") {
        that.branchList.push(parseInt(item.id));
        that.choosedBranch.push(item);
      } else if (item.itype == "3" && item.type == "3") {
        that.orgList.push(parseInt(item.id));
        that.choosedOrg.push(item);
      }
    });
    that.choosedPeople = that.friend;
    that.choosedGroup = that.group;
    that.chooseddq = that.dq;
    that.choosedhy = that.hy;
    if (window.localStorage.getItem("trueBtn") == 1) {
      that.trueBtnStatus = true;
    }
  },
  updated() {
    this.allTotal =
      this.peopleTotal +
      this.groupTotal +
      this.orgTotal +
      this.branchTotal +
      this.dqTotal +
      this.hyTotal;
  },
  methods: {
    chooseCheck(val, item) {
      var that = this;
      if (val) {
        if (item.itype == "1" || (item.itype == "3" && item.type == "1")) {
          this.choosedPeople.push(item);
          that.result.push(parseInt(item.umid));
        } else if (item.itype == "2") {
          this.choosedGroup.push(item);
          this.result.push(item.id);
        } else if (item.itype == "3" && item.type === "3") {
          this.choosedOrg.push(item);
        } else if (item.itype == "3" && item.type === "2") {
          this.choosedBranch.push(item);
        } else if (!that.dq_status) {
          item.itype = "5";
          this.chooseddq.push(item);
        } else if (!that.hy_status) {
          item.itype = "6";
          this.choosedhy.push(item);
        }else{
          this.choosedRoomuser.push(item);
        }
      } else {
        if (item.itype == "1" || (item.itype == "3" && item.type == "1")) {
          this.choosedPeople.forEach((m, i) => {
            if (item.id == m.id) {
              this.choosedPeople.splice(i, 1);
            }
          });
          this.result.forEach((m, i) => {
            if (m == item.umid) {
              this.result.splice(i, 1);
            }
          });
        } else if (item.itype == "2") {
          this.choosedGroup.forEach((m, i) => {
            if (item.id == m.id) {
              this.choosedGroup.splice(i, 1);
            }
          });
          this.result.forEach((m, i) => {
            if (m == item.id) {
              this.result.splice(i, 1);
            }
          });
        } else if (item.itype == "3" && item.type === "3") {
          this.choosedOrg.forEach((m, i) => {
            if (item.id == m.id) {
              this.choosedOrg.splice(i, 1);
            }
          });
        } else if (item.itype == "3" && item.type === "2") {
          this.choosedBranch.forEach((m, i) => {
            if (item.id == m.id) {
              this.choosedBranch.splice(i, 1);
            }
          });
        } else if (!that.dq_status) {
          this.chooseddq.forEach((m, i) => {
            if (item.id == m.id) {
              this.chooseddq.splice(i, 1);
            }
          });
        } else if (!that.hy_status) {
          this.choosedhy.forEach((m, i) => {
            if (item.id == m.id) {
              this.choosedhy.splice(i, 1);
            }
          });
        } else{
          this.choosedRoomuser.forEach((m, i) => {
            if (item.umid == m.umid) {
              this.choosedRoomuser.splice(i, 1);
            }
          });
        }
      }
    },
    recentChange(val, item) {
      var that = this;
      if (val) {
        if (item.type == 1) {
          this.peopleList.push(parseInt(item.users.umid));
          this.choosedPeople.push(item);
        } else if (item.type == 2) {
          this.groupList.push(item.roominfo.roomid);
          this.choosedGroup.push(item);
        }
      } else {
        if (item.type == 1) {
          for (let i = 0; i < that.peopleList.length; i++) {
            if (item.users.umid == that.peopleList[i]) {
              that.peopleList.splice(i, 1);
              that.choosedPeople.splice(i, 1);
            }
          }
        } else if (item.type == 2) {
          for (let i = 0; i < that.groupList.length; i++) {
            if (item.roominfo.roomid == that.groupList[i]) {
              that.groupList.splice(i, 1);
              that.choosedGroup.splice(i, 1);
            }
          }
        }
      }
    },
    goBack1() {
      this.choosedStatus = true;
    },
    removeThis(val, index, type) {
      var that = this;
      console.log(val.itype,val.type,type)
      if (val.itype == "1" || val.type === 1) {
        that.peopleList.splice(index, 1);
        that.choosedPeople.splice(index, 1);
        if (val.unit) {
          that.result.splice(index, 1);
        }
      } else if (val.itype == "2" || val.type === 2) {
        that.groupList.splice(index, 1);
        that.choosedGroup.splice(index, 1);
        if (val.unit) {
          that.result.splice(index, 1);
        }
      } else if (val.itype == "3" && val.type === "3") {
        that.orgList.splice(index, 1);
        that.choosedOrg.splice(index, 1);
      } else if (val.itype == "3" && val.type === "2") {
        that.branchList.splice(index, 1);
        that.choosedBranch.splice(index, 1);
      } else if (type == 1) {
        that.dqList.splice(index, 1);
        that.chooseddq.splice(index, 1);
      } else if (type == 0) {
        that.hyList.splice(index, 1);
        that.choosedhy.splice(index, 1);
      } else if(type==3){
        that.peopleList.splice(index, 1);
        that.choosedRoomuser.splice(index, 1);
      }
    },
    removeAll(type) {
      var that = this;
      if (type == 1) {
        this.peopleList = [];
        this.choosedPeople = [];
        this.result = [];
      } else if (type == 2) {
        this.groupList = [];
        this.choosedGroup = [];
        this.result = [];
      } else if (type == 3) {
        this.orgList = [];
        this.choosedOrg = [];
      } else if (type == 4) {
        this.branchList = [];
        this.choosedBranch = [];
      } else if (type == 5) {
        this.hyList = [];
        this.choosedhy = [];
      } else if (type == 6) {
        this.dqList = [];
        this.chooseddq = [];
      }
    },
    goBack() {
      if (window.localStorage.getItem("msgToCre") == 1) {
        $(".hudong").show();
        $(".tongxunlu").hide();
        $UMCore.msg({
          cmd: "restart",
          op: "restartTabbar",
          data: { type: "tongxunlu" }
        });
        $UMCore.msg({
          cmd: "showTabbar",
          op: "isShowTabbar",
          data: { show: true }
        });
      } else if (window.localStorage.getItem("mcreGroupType") == 1) {
        $UMCore.msg({
          cmd: "restart",
          op: "restartTabbar",
          data: { type: "tongxunlu" }
        });
        $UMCore.msg({
          cmd: "showTabbar",
          op: "isShowTabbar",
          data: { show: true }
        });
      } else if (window.localStorage.getItem("listToCre") == 1) {
        $UMCore.msg({ cmd: "toGroupList", op: "isShowGroupList" });
      }
      this.$emit("closeSelector");
      this.$emit("createQrcode");
      window.localStorage.removeItem("msgToCre");
      window.localStorage.removeItem("mcreGroupType");
      window.localStorage.removeItem("trueBtn");
      window.localStorage.removeItem("listToCre");
    },
    submit() {
      if (window.localStorage.getItem("trueBtn") == 1) {
        $UMCore.compile("chooseDetail", JSON.stringify(this.choosedPeople));
        $UMCore.msg({ cmd: "toGroupChat", op: "showGroupChat" });
      } else {
        // id混合数组
        var arr = this.peopleList.concat(this.groupList);
        var newArr = arr.concat(this.orgList);
        var newArr1 = newArr.concat(this.hyList);
        var newArr2 = newArr1.concat(this.dqList);
        var new_arr = newArr2.concat(this.branchList);

        //item组合成的数组
        var itemArr = this.choosedPeople.concat(this.choosedGroup);
        var newItemArr = itemArr.concat(this.choosedOrg);
        var newItemArr3 = newItemArr.concat(this.choosedRoomuser);
        var newItemArr1 = newItemArr3.concat(this.chooseddq);
        var newItemArr2 = newItemArr1.concat(this.choosedhy);
        var new_item_arr = newItemArr2.concat(this.choosedBranch);
        this.goBack();
      }
      this.$emit("choosedId", new_arr);
      this.$emit("choosedItem", new_item_arr);
    },
    // 最近联系人
    getRecent() {
      var that = this;
      var recentId = [];
      var recentType = [];
      $UMCore
        .post("route.lua", {
          data: JSON.stringify({
            functionname: "msg_getdisuser",
            umid: $UMCore.uncompile("umid")
          })
        })
        .then(function(response) {
          if (response.data.status) {
            that.slist = response.data.result.slice(0, 10);
            that.slist.forEach((val, index) => {
              if (
                val.type == 1 &&
                val.users.umid == $UMCore.uncompile("umid")
              ) {
                that.slist.splice(index, 1);
              }
            });
            for (let i = 0; i < that.slist.length; i++) {
              if (that.slist[i].type == 1) {
                recentId.push(that.slist[i].users.umid);
                recentType.push(that.slist[i].type);
              } else if (that.slist[i].type == 2) {
                recentId.push(that.slist[i].roominfo.roomid);
                recentType.push(that.slist[i].type);
              }
            }
            for (let i = 0; i < recentId.length; i++) {
              var obj = {};
              obj.unitId = recentId[i];
              obj.type = recentType[i];
              that.slist[i].unit = obj;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    changeStatus() {
      this.status = true;
      this.friend_status = true;
      this.group_status = true;
      this.org_status = true;
      this.hy_status = true;
      this.dq_status = true;
      this.breadArr = [];
      this.branchId = "";
      this.org_list = [];
      this.orgmember = [];
    },
    /**
      获取我的好友
     */
    getMyFriend() {
      var that = this;
      var obj = {};
      obj.name = "我的好友";
      that.breadArr.push(obj);
      that.status = false;
      that.friend_status = false;
      var umid = $UMCore.uncompile("umid");
      if (that.clickFriend) {
        $UMCore
          .post("route.lua", {
            data: JSON.stringify({
              functionname: "userlist_get",
              itype: 1,
              umid: umid
            })
          })
          .then(function(res) {
            if (res.data.result === 0) {
              that.friend_list = res.data.slist;
              that.clickFriend = false;
              let obj = {};
              let arr = [];
              that.friend_list.forEach(function(value, index, array) {
                value.capitalize = that
                  .makePy(value.name)[0]
                  .toUpperCase()
                  .substr(0, 1);
                var reg = /^[A-Z]+$/;
                if (!value.capitalize.match(reg)) {
                  value.capitalize = "#";
                }
                if (!obj[value.capitalize]) {
                  obj[value.capitalize] = true;
                  arr.push(value.capitalize);
                }
              });
              //字母列表排序
              that.letters = arr.sort();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    makePy(str) {
      if (typeof str != "string")
        throw new Error(-1, "函数makePy需要字符串类型参数!");
      let arrResult = new Array(); //保存中间结果的数组
      for (let i = 0, len = str.length; i < len; i++) {
        //获得unicode码
        let ch = str.charAt(i);
        //检查该unicode码是否在处理范围之内,在则返回该码对映汉字的拼音首字母,不在则调用其它函数处理
        arrResult.push(this.checkCh(ch));
      }
      //处理arrResult,返回所有可能的拼音首字母串数组
      return this.mkRslt(arrResult);
    },
    checkCh(ch) {
      let uni = ch.charCodeAt(0);
      //如果不在汉字处理范围之内,返回原字符,也可以调用自己的处理函数
      if (uni > 40869 || uni < 19968) return ch; //dealWithOthers(ch);
      //检查是否是多音字,是按多音字处理,不是就直接在this.strChineseFirstPY字符串中找对应的首字母
      return this.oMultiDiff[uni]
        ? this.oMultiDiff[uni]
        : this.strChineseFirstPY.charAt(uni - 19968);
    },
    mkRslt(arr) {
      let arrRslt = [""];
      for (let i = 0, len = arr.length; i < len; i++) {
        let str = arr[i];
        let strlen = str.length;
        if (strlen == 1) {
          for (let k = 0; k < arrRslt.length; k++) {
            arrRslt[k] += str;
          }
        } else {
          let tmpArr = arrRslt.slice(0);
          arrRslt = [];
          for (let k = 0; k < strlen; k++) {
            //复制一个相同的arrRslt
            let tmp = tmpArr.slice(0);
            //把当前字符str[k]添加到每个元素末尾
            for (let j = 0; j < tmp.length; j++) {
              tmp[j] += str.charAt(k);
            }
            //把复制并修改后的数组连接到arrRslt上
            arrRslt = arrRslt.concat(tmp);
          }
        }
      }
      return arrRslt;
    },
    getMyGroup() {
      var that = this;
      var obj = {};
      obj.name = "我的群组";
      that.breadArr.push(obj);
      that.status = false;
      that.group_status = false;
      if (that.clickGroup) {
        $UMCore
          .post("route.lua", {
            data: JSON.stringify({
              functionname: "userlist_get",
              itype: 2,
              umid: $UMCore.uncompile("umid")
            })
          })
          .then(function(res) {
            that.group_list = res.data.slist;
            that.clickGroup = false;
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    // 面包屑任意一级
    goSon(e, item) {
      var that = this;
      for (let i = 0; i < that.breadArr.length; i++) {
        if (item.id == that.breadArr[i].id) {
          that.breadArr.splice(i + 1);
        }
      }
      if (item.type != undefined) {
        var umid = $UMCore.uncompile("umid");
        var orgid = item.orgid;
        var deptno = item.deptno;
        $UMCore
          .post("route.lua", {
            data: JSON.stringify({
              functionname: "userlist_get",
              itype: 3,
              umid: umid,
              orgid: orgid,
              deptno: deptno
            })
          })
          .then(function(res) {
            if (res.data.status) {
              that.orgmember = res.data.slist;
              that.orgmember.forEach((val, index) => {
                if (val.type == "1") {
                  that.peopleStatus = true;
                } else if (val.type == "2") {
                  that.branchStatus = true;
                }
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        that.getMyOrg(1);
      }
    },
    // 面包屑任意一级
    godqSon(e, item) {
      var that = this;

      if (item.id == 0) {
        that.getdq();
      } else {
        let e = {
          id: item.id,
          name: item.name
        };
        that.getBranchdq(e);
      }
      for (let i = 0; i < that.breadArr.length; i++) {
        if (item.id == that.breadArr[i].id) {
          that.breadArr.splice(i + 1);
        }
      }
    },
    // 面包屑任意一级
    gohySon(e, item) {
      var that = this;

      if (item.id == 0) {
        that.gethy();
      } else {
        let e = {
          id: item.id,
          name: item.name
        };
        that.getBranchhy(e);
      }
      for (let i = 0; i < that.breadArr.length; i++) {
        if (item.id == that.breadArr[i].id) {
          that.breadArr.splice(i + 1);
        }
      }
    },
    // 获取组织
    getMyOrg(inData = null) {
      var that = this;
      if (inData == null) {
        var obj = {};
        obj.name = "我的组织";
        that.breadArr.push(obj);
      }
      that.status = false;
      that.org_status = false;
      that.orgRoot = true;
      that.orgmember = [];
      var umid = $UMCore.uncompile("umid");
      if (that.clickOrg) {
        $UMCore
          .post("route.lua", {
            data: JSON.stringify({
              functionname: "userlist_get",
              umid: umid,
              itype: 3
            })
          })
          .then(function(res) {
            if (res.data.result === 0) {
              that.org_list = res.data.slist;
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    // 获取地区
    getdq(inData = null) {
      var that = this;
      if (inData == null) {
        var obj = {};
        obj.name = "地区";
        that.breadArr.push(obj);
      }
      that.status = false;
      that.dq_status = false;
      that.dqRoot = true;
      that.dqmember = [];
      var umid = $UMCore.uncompile("umid");
      if (that.clickdq) {
        $UMCore
          .post(window.zt_server + "/route.lua", {
            data: JSON.stringify({
              modulename: "area",
              functionname: "get",
              pid: 0
            })
          })
          .then(res => {
            this.dq_list = res.data.data.slist;
          });
        // $UMCore.post('route.lua', {
        //   data:JSON.stringify({
        //     functionname: 'userlist_get',
        //     umid: umid,
        //     itype: 3
        //   })
        // })
        // .then(function(res){
        //   if (res.data.result === 0) {
        //     that.org_list = res.data.slist
        //   }
        // })
        // .catch(function (error) {
        //   console.log(error)
        // })
      }
    },
    // 获取行业
    gethy(inData = null) {
      var that = this;
      if (inData == null) {
        var obj = {};
        obj.name = "行业";
        that.breadArr.push(obj);
      }
      that.status = false;
      that.hy_status = false;
      that.hyRoot = true;
      that.hymember = [];
      var umid = $UMCore.uncompile("umid");
      if (that.clickhy) {
        $UMCore
          .post(window.zt_server + "/route.lua", {
            data: JSON.stringify({
              modulename: "industry",
              functionname: "get",
              pid: 0
            })
          })
          .then(res => {
            this.hy_list = res.data.data.slist;
          });
      }
    },
    getBranch(e) {
      var that = this;
      this.orgRoot = false;
      this.orgid = e.orgid;
      this.breadArr.push(e);
      var umid = $UMCore.uncompile("umid");
      // type值为1的时候  不在继续请求
      if (e.type !== "1") {
        that.branchId = e.deptno;
        $UMCore
          .post("route.lua", {
            data: JSON.stringify({
              functionname: "userlist_get",
              itype: 3,
              umid: umid,
              orgid: that.orgid,
              deptno: that.branchId
            })
          })
          .then(function(res) {
            if (res.data.status) {
              that.orgmember = res.data.slist;
              if (that.orgmember.length == 0) {
                that.peopleStatus = false;
                that.branchStatus = false;
              } else {
                that.orgmember.forEach((val, index) => {
                  if (val.type == "1") {
                    that.peopleStatus = true;
                  } else if (val.type == "2") {
                    that.branchStatus = true;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    getBranchhy(e) {
      var that = this;
      this.hyRoot = false;
      this.breadArr.push(e);
      var umid = $UMCore.uncompile("umid");
      // type值为1的时候  不在继续请求
      $UMCore
        .post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "industry",
            functionname: "get",
            pid: e.id
          })
        })
        .then(res => {
          that.hymember = res.data.data.slist;
          that.$forceUpdate();
        });
    },
    getBranchdq(e) {
      var that = this;
      this.dqRoot = false;
      this.breadArr.push(e);
      var umid = $UMCore.uncompile("umid");
      // type值为1的时候  不在继续请求
      $UMCore
        .post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "area",
            functionname: "get",
            pid: e.id
          })
        })
        .then(res => {
          that.dqmember = res.data.data.slist;
          that.$forceUpdate();
        });
    },
    toChoosedPeople() {
      this.choosedStatus = false;
    }
  }
};
</script>
<style scoped lang="scss">
.choosepeople {
  height: 100%;
  width: 100%;
  overflow: auto;
  background: #fff;
  position: fixed;
  z-index: 9;
}
.big_box {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-top: 100px;
  background: #f7f7f7;
}
.bread {
  width: 100%;
  border-bottom: 1px solid #eee;
  margin-top: 100px;
  padding: 10px 15px;
  height: 42px;
  overflow: hidden;
  color: #dadada;
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 2;
  .bread_ul {
    white-space: nowrap;
    overflow-x: auto;
    li {
      display: inline-block;
      font-size: 16px;
      color: #2e9cf1;
    }
    li:nth-last-child(1) {
      color: #666;
    }
  }
}
.searchBox {
  width: 100%;
  background: #fff;
  padding-top: 65px;
  position: fixed;
  padding-bottom: 10px;
  z-index: 2;
  .search {
    background-color: #f3f3f3;
    text-align: center;
    width: 93%;
    border-radius: 3px;
    color: #bfbfbf;
    line-height: 20px;
    padding: 7px 0;
    margin: 0 auto;
  }
}
.list {
  margin-top: 10px;
  background: #fff;
  width: 100%;
}
.search i {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url("/img/fangdajing_sel.png") no-repeat;
  background-size: 16px;
  vertical-align: middle;
}
.myList {
  width: 100%;
  overflow: hidden;
  .myUl {
    width: 100%;
    overflow: hidden;
  }
}
.myLi,
.recentList {
  width: 100%;
  background-color: #fff;
  padding: 10px 15px;
  float: left;
  .avatar,
  .no_avatar {
    float: left;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    line-height: 40px;
    color: #fff;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
  .no_avatar {
    background: #34b2fd;
  }
  .name {
    line-height: 40px;
    margin-left: 10px;
    font-size: 15px;
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: left;
    img {
      width: 20px;
      height: 20px;
      float: left;
      margin-top: 10px;
      margin-left: 10px;
    }
  }
}
.recent {
  color: #999999;
  font-size: 12px;
  padding: 10px 15px;
}
.recentList {
  background: #fff;
  width: 100%;
  margin-bottom: 53px;
  .el-checkbox {
    line-height: 60px;
    height: 60px;
    width: 100%;
    .el-checkbox__label {
      font-size: 15px;
      color: #333333;
      width: 100%;
    }
  }
}
.people_list,
.group_list,
.org_list {
  padding-top: 5px;
  margin-bottom: 53px;
  margin-top: 140px;
  width: 100%;
  overflow: hidden;
}
.member_list {
  width: 100%;
  .list_ul {
    width: 100%;
    .section {
      width: 100%;
      margin: 5px 0;
      background-color: #f6f6f6;
      overflow: hidden;
      .letter {
        padding: 0 15px;
        color: #9a9a9c;
        line-height: 25px;
        font-size: 15px;
      }
      .el-checkbox-group {
        overflow: hidden;
        background: #fff;
        .el-checkbox {
          width: 100%;
          float: left;
          font-size: 12px;
          line-height: 20px;
          padding: 10px 15px;
          border-bottom: 1px solid #ededed;
          /deep/ .el-checkbox__label {
            width: calc(100% - 30px);
            .avatar {
              width: 40px;
              height: 40px;
              float: left;
              img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                object-fit: cover;
              }
              .noAvatar {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background-color: #34b2fd;
                text-align: center;
                line-height: 40px;
                color: #fff;
              }
            }
            .name_phone {
              float: left;
              margin-left: 10px;
              height: 40px;
              display: flex;
              align-items: left;
              justify-content: space-around;
              flex-direction: column;
              padding-top: 2px;
              max-width: 55%;
              p {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .name {
                float: left;
                color: #000000;
                font-size: 14px;
              }
              .phone {
                clear: both;
                color: #666666;
              }
            }
            .company {
              float: right;
              text-align: right;
              max-width: 30%;
              p {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        .van-checkbox:last-child {
          border: none;
        }
      }
    }
  }
}
.groupUl {
  float: left;
  width: 100%;
  background: #fff;
  .el-checkbox {
    padding: 10px 15px;
    width: 100%;
    border-bottom: 1px solid #ededed;
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      float: left;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .right {
      max-width: calc(100% - 50px);
      margin-left: 10px;
      height: 40px;
      line-height: 40px;
      float: left;
      span {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }
  }
  .el-checkbox:last-child {
    border: none;
  }
}
.orglist {
  width: 100%;
  overflow: hidden;
  background: #f7f7f7;
  .org_ul {
    width: 100%;
    float: left;
    line-height: 25px;
    padding: 0 15px;
    padding-top: 10px;
    background: #fff;
    .el-checkbox {
      overflow: hidden;
      width: calc(100% - 69px);
      /deep/ .el-checkbox__label {
        width: 100%;
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          float: left;
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
          }
        }
        .noAvatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #34b2fd;
          float: left;
          text-align: center;
          line-height: 40px;
          color: #fff;
        }
        .name {
          margin-left: 10px;
          float: left;
          max-width: 80%;
          line-height: 40px;
          span {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            float: left;
            font-size: 16px;
            font-weight: 500;
            max-width: 100%;
          }
          img {
            width: 20px;
            height: 20px;
            float: left;
            margin-top: 10px;
            margin-left: 10px;
          }
        }
      }
    }
    li {
      .next {
        float: right;
        color: #2e9cf1;
        line-height: 40px;
        font-size: 14px;
        img {
          width: 12px;
          height: 16px;
        }
      }
    }
  }
  .manList {
    margin-top: 10px;
  }
  .rightBox {
    float: left;
    margin-left: 10px;
    width: calc(100% - 10px);
    .name {
      float: left;
      line-height: 40px;
      font-size: 16px;
    }
    .job {
      float: right;
      line-height: 40px;
    }
  }
}
.sure {
  width: 100%;
  float: left;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  padding: 10px 15px;
  line-height: 32px;
  border-top: 1px solid #ededed;
}
.sure .left {
  float: left;
}
.sure .choosedPeople {
  float: left;
  height: 100%;
  overflow: hidden;
}
.sure .right {
  float: right;
}
.choosepeople::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.22);
}
@media (max-width: 750px) {
  .choosepeople {
    width: 100%;
    height: 100%;
  }
}
.special {
  width: 100%;
  height: 100%;
  overflow: auto;
  .big_box {
    width: 100%;
    height: 100%;
    overflow: auto;
    padding-top: 70px;
    background: #fff;
    .listUl {
      width: 100%;
      overflow: hidden;
      .listLi {
        width: 100%;
        line-height: 40px;
        font-size: 15px;
        padding: 10px 15px;
        float: left;
        border-bottom: 1px solid #ededed;
        .avatar,
        .no_avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          float: left;
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
          }
        }
        .no_avatar {
          background: #3696fa;
          text-align: center;
          color: #fff;
          line-height: 40px;
        }
        .name {
          float: left;
          margin-left: 15px;
        }
        .remove {
          float: right;
          color: #fb6155;
        }
      }
      .listLi:last-child {
        border: none;
      }
      .classify {
        background: #f6f6f6;
        color: #9a9a9c;
        clear: both;
        padding: 5px 15px;
      }
    }
  }
}
.spectial {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 2;
}
</style>
<style>
.choosepeople .el-checkbox-group > .el-checkbox + .el-checkbox {
  color: #333;
  margin: 0;
}
.choosepeople .el-checkbox__input > .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.choosepeople .el-checkbox__input > .el-checkbox__inner::after {
  left: 7px;
  top: 4px;
}
.choosepeople
  .el-checkbox
  > .el-checkbox__input.is-checked
  + .el-checkbox__label {
  color: #333;
}
.choosepeople .el-checkbox > .el-checkbox__input {
  margin-top: -30px;
}
</style>



// WEBPACK FOOTER //
// src/packages/mselector/um-mselector.vue